import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const GridOrder = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 448 512" {...props}>
      <path
        opacity={0.3}
        fill={props.htmlColor || theme.palette.secondary[300]}
        d="M0 328L0 440c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L40 288c-22.1 0-40 17.9-40 40zM256 72l0 112c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L296 32c-22.1 0-40 17.9-40 40z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[300]}
        d="M192 80c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM448 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z"
      />
    </SvgIcon>
  );
};
